module.exports = __webpack_public_path__ + "img/multiple-choice.a26e80db.svg";